import React from "react";
import { lazyWithRetry } from "utils/lazy-with-retry";

const LazyDataQuery = lazyWithRetry(() => import("./DataQuery"));

const DataQuery = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazyDataQuery {...props} />;

export default DataQuery;
